<template>
    <div class="card-top top-image" v-if="viewType === 'moodview'">
        <!--<img :src="topic.attachments[0].source" alt="">-->
        <lightbox :images="image" thumbnailSrc="source" src="source" customImageClass="hover" :compressThumbnail="false"></lightbox>
        <div class="close-moodview hover" @click="closeMoodview">
            <i class="fal fa-times"></i>
        </div>
    </div>
</template>

<script>
    import cloneDeep from 'lodash.clonedeep';

    export default {
        props: {
            viewType: {
                required: true
            },
            topic: {
                required: true
            }
        },

        computed: {
            image() {
                return this.topic.attachments.filter((attachment) => attachment.id);

            }
        },

        methods: {
            closeMoodview() {
                this.$store.commit('setMoodview', false);
            }
        }
    }
</script>